<template>
    <form class="px-4 py-3">
        <div class="mb-3">
            <input type="text" class="form-control" placeholder="Label" v-model="tab.label">
        </div>

        <div class="mb-3">
            <select class="form-select" v-model="tab.resource" @change="onViewSelected">
                <option value="" disabled>Select view</option>
                <option v-for="view in views" :value="view.id">{{view.name}}</option>
            </select>
        </div>

        <button type="submit" class="btn btn-primary" @click.prevent="onSaveClick">save</button>
    </form>
</template>

<script>
    import AppService from "../../services/AppService";

    export default {
        name: 'NewTabForm',
        props: ['prop1', 'prop2'],
        data () {
            return {
                model: webase.model,
                tab: {
                    label: '',
                    icon: '',
                    resourceType: 'View',
                    resource: '',
                    resourceName: '',
                },
                service: new AppService()
            }
        },
        computed: {
            views() {
                let appViews = webase.managers.app.getViews()
                return appViews
            }
        },
        mounted () {
            this.clearTabData()
        },
        methods: {
            onSaveClick () {
                if(this.tab.label && this.tab.resource) {
                    let newTab = JSON.parse(JSON.stringify(this.tab))
                    this.model.app.nav.tabs.push(newTab)
                    let request = {
                        app: this.model.app
                    }

                    let promise = this.service.update(this.model.app.id, request)

                    promise.then((response) => {
                        console.log('App saved')
                        console.log(response)
                        this.clearTabData()
                    }).catch((message) => {
                        console.log('error saving app')
                        console.log(message)
                        webase.utils.notification.error(message)
                    })

                    $('#newTabDropdownButton').dropdown('toggle')
                }
            },

            onViewSelected () {
                let view = webase.managers.app.getView(this.tab.resource)
                this.tab.resourceName = view.name
            },

            clearTabData () {
                this.tab.label = ''
                this.tab.resource = ''
                this.tab.resourceName = ''
            }
        }
    }
</script>

<style>

</style>
